import { featureCollection } from '@turf/helpers'
import { toWgs84 } from '@turf/projection'
import $ from 'jquery'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import merge from 'lodash/merge'
import OLCollection from 'ol/Collection'
import OLInteractionModify from 'ol/interaction/Modify'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziGeoServer from 'drawer/tabs/info/geoserver'
import PoziMap from 'map/map'

export default function PoziEditFeature () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    }
  }

  const app = PoziUtils.getApp()

  var init = function () {
    Model.on('app.event.drawer.tabs.info.card.open', _onCardOpen)
    Model.on('app.event.drawer.tabs.info.card.open', _addDatePickers)
    Model.on('app.event.drawer.tabs.info.card.save.button.clicked', _removeInteraction)
    Model.on('app.event.drawer.tabs.info.card.cancel.button.clicked', _removeInteraction)
    Model.on('app.event.drawer.tabs.info.card.cancel.button.clicked', _refreshAllLayers)
    Model.on('app.event.drawer.tabs.info.card.delete.button.clicked', _removeInteraction)
    Model.on('app.event.drawer.closing', _removeInteraction)
    Model.on('app.event.drawer.closed', _refreshAllLayers)
    Model.on('app.event.map.click.single', _removeInteraction)
  }

  var _addDatePickers = function () {
    if (!Model.get('app.event.geoserver.loggedin', false)) {
      return
    }
    console.log('Add datepickers...')
    $('.pika-single').remove()
    $('.datepicker').each(function (index) {
      console.log(index + ': ' + $(this).text())
      const pOptions = {
        field: $(this)[0],
        firstDay: 1,
        minDate: new Date(1980, 0, 1),
        maxDate: new Date(2030, 12, 31),
        yearRange: [1980, 2030],
        showTime: false,
        autoClose: false,
        use24hour: false,
        format: 'YYYY-MM-DD[Z]'
      }
      const a = new window.Pikaday(pOptions)
      console.log('Pikaday', a)
    })
    $('#elt-tabs .panel-group').on('change', '.editable-input.datepicker', function (evt) {
      Model.set('app.event.drawer.tabs.info.data.editable.input.changed', evt)
    })
  }

  var _onCardOpen = function (options) {
    const layer = get(options, 'layer', null)
    if (isNil(layer)) {
      console.log('No layer set to determine if this is an editable feature.')
      return
    }
    const bEditableLayer = PoziGeoServer().isGeoServerLayerAndLoggedIn(layer)
    if (bEditableLayer) {
      console.log('PoziEditFeature()._onCardOpen()', bEditableLayer)
      _addInteraction()
    }
  }

  var _refreshAllLayers = function () {
    if (!Model.get('app.event.geoserver.loggedin', false)) {
      return
    }
    PoziMap().refreshAllLayers()
  }

  var _addInteraction = function () {
    if (!Model.get('app.event.geoserver.loggedin', false)) {
      return
    }
    const olFeature = Model.get('app.map.target.ol.feature')
    const olCollection = new OLCollection([olFeature])
    const modify = new OLInteractionModify({
      features: olCollection
    })
    Model.set('app.map.feature.edit.interaction.modify', modify)
    modify.on('modifyend', _onModifyEnd)
    app.map.addInteraction(modify)
  }

  var _onModifyEnd = function (evt) {
    if (!Model.get('app.event.geoserver.loggedin', false)) {
      return
    }

    console.log('_onModifyEnd', evt)
    if (isNil(evt) || isNil(evt.features)) {
      console.log('Unable to find features in event??')
      return
    }
    const olFeaturesArrModified = evt.features.getArray()
    if (olFeaturesArrModified.length === 1) {
      // ol.Collection
      const olFeatureModified = olFeaturesArrModified[0]
      const turfFeatureModified = PoziUtils.convertOLFeatureToTurfFeature(olFeatureModified)
      let featureCollectionModified = featureCollection([turfFeatureModified])
      featureCollectionModified = toWgs84(featureCollectionModified)

      const featureGeomModified = get(featureCollectionModified, 'features[0].geometry', null)
      // console.log('_onModifyEnd feature', featureGeomModified)
      const featurecollectionGeomTarget = Model.get('app.map.target.featurecollection.features[0].geometry', null)
      // console.log('_onModifyEnd featurecollectionGeomTarget', featurecollectionGeomTarget)

      merge(featurecollectionGeomTarget, featureGeomModified)

      console.log('_onModifyEnd featurecollection check lat/lng', Model.get('app.map.target.featurecollection', null))
    }
  }

  var _removeInteraction = function () {
    if (!Model.get('app.event.geoserver.loggedin', false)) {
      return
    }
    console.log('_removeInteraction: start')
    const modify = Model.get('app.map.feature.edit.interaction.modify', null)
    if (!isNil(modify)) {
      app.map.removeInteraction(modify)
      Model.unset('app.map.feature.edit.interaction.modify')
      console.log('_removeInteraction: Removed edit feature interaction.')
    } else {
      console.log('_removeInteraction: No modify object found.')
    }
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
